<!-- prettier-ignore -->
@if (control.errors && displayConditionMet) {
  <small [attr.id]="id" [pluginsAnimation]="animations" >
    @for (error of control.errors | keyvalue; track error.key) {
        {{ 'form.formControlError.' + error.key | translate: translateVars }}@if (displayValue && typeof error.value === 'string') {: {{ error.value }}}.&nbsp;
    }
  </small>
}
